import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { HotelFacts, HotelFactsMobile } from '@lt/components';
import styled from 'styled-components';

import getFactsItemData from '../../utils/getFactsItemData';
import { getHotelFacts } from '../../store/selectors/hotel';
import { HOTEL_FACTS_ORDER } from '../../constants/hotelFacts';
import FactsIcon from './FactsIcon';

// TODO: убрать класс (на нем завязаны легаси иконки)
const baseClsFacts = 'hotel-info__facts';

const StyledHotelFactsMobile = styled(HotelFactsMobile)`
  margin-bottom: 20px;
`;

const Facts = ({ isMobile, facts }) => {
  const factsData = HOTEL_FACTS_ORDER.map((type) => {
    const item = getFactsItemData(type, facts[type]);
    return item
      ? {
          ...item,
          icon: <FactsIcon type={item.iconName} isMobile={isMobile} />,
        }
      : null;
  }).filter(Boolean);
  const Component = isMobile ? StyledHotelFactsMobile : HotelFacts;

  return <Component className={baseClsFacts} facts={factsData} />;
};

Facts.defaultProps = {
  isMobile: false,
};

Facts.propTypes = {
  isMobile: PropTypes.bool,
  facts: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  facts: getHotelFacts(state),
});

export default connect(mapStateToProps)(Facts);
